// USER
export const SET_USER = 'SET_USER';

// NOTIFICATIONS
export const REQUEST_NOTIFICATIONS = 'REQUEST_NOTIFICATIONS';
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const VIEWED_NOTIFICATION = 'VIEWED_NOTIFICATION';
export const UPDATE_LAST_SEEN_NOTIFICATION = 'UPDATE_LAST_SEEN_NOTIFICATION';
export const REMOVE_SUGGESTION = 'REMOVE_SUGGESTION';

// PROJECT
export const TOGGLE_PANDA_BOX = 'TOGGLE_PANDA_BOX';

// ORGANISATION
export const SELECT_ORGANISATION = 'SELECT_ORGANISATION';

// SUBSCRIPTION
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';

// MODALS
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

// DISPLAY
export const TOGGLE_DISCOVER_VITRINE_BOX = 'TOGGLE_DISCOVER_VITRINE_BOX';
export const TOGGLE_DISCOVER_BDR_BOX = 'TOGGLE_DISCOVER_BDR_BOX';
